import React from "react"

const TransactionsHistory = () => {
  return (
    <ul className="transactionsHistory">
      <li>
        <img
          className="transactionsHistory-icon"
          src="/images/Section4/detailed-transactions.svg"
          alt="Detailed transactions icon"
        />
        <div className="transactionsHistory-info">
          <h3>Detailed transaction history</h3>
          <h5>Know what, where, and how you spent or received money</h5>
        </div>
      </li>
      <li>
        <img
          className="transactionsHistory-icon"
          src="/images/Section4/categories.svg"
          alt="Categories icon"
        />
        <div className="transactionsHistory-info">
          <h3>Categorise your finances</h3>
          <h5>Oversee how your finances are distributed</h5>
        </div>
      </li>
      <li>
        <img
          className="transactionsHistory-icon"
          src="/images/Section4/periodic-reports.svg"
          alt="Periodic reports icon"
        />
        <div className="transactionsHistory-info">
          <h3>Receive periodic reports of your balance</h3>
          <h5>Monitor your financial health on a steady basis</h5>
        </div>
      </li>
      <li>
        <img
          className="transactionsHistory-icon"
          src="/images/Section4/suspicious.svg"
          alt="Suspicious icon"
        />
        <div className="transactionsHistory-info">
          <h3>Report any suspicious activity</h3>
          <h5>Ensure your finances are safely protected</h5>
        </div>
      </li>
    </ul>
  )
}

export default TransactionsHistory
